export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-310x310-833594a6820902555bdcd2603359bc0f.png";